import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_COUNTRY_CODE } from '../../../../../utils/constants';
import { CheckboxesField } from '../../../../01_atoms/FormElements';
import FormattedText from '../../../../01_atoms/FormattedText';

export const getDefaultDescriptionForContactPreferences = () => {
  if (DEFAULT_COUNTRY_CODE === 'IE') {
    return (
      <p className="description">
        You may already have opted into some of our marketing, in which case we will continue to
        rely on that permission. We will also keep you updated by post. You can opt out of postal &
        other marketing by contacting us at{' '}
        <a href="mailto:preferences@concern.net" target="_blank" rel="noopener noreferrer">
          preferences@concern.net
        </a>
        . For further information please see our{' '}
        <a href="https://www.concern.net/privacy" target="_blank" rel="noopener noreferrer">
          privacy policy
        </a>
        .
      </p>
    );
  }

  if (DEFAULT_COUNTRY_CODE === 'GB') {
    return (
      <p className="description">
        You can change your preferences at any time by contacting us at{' '}
        <a href="mailto:enquiries.info@concern.net" target="_blank" rel="noopener noreferrer">
          enquiries.info@concern.net
        </a>{' '}
        or by calling 0800 032 4001. For further information please see our{' '}
        <a
          href={
            DEFAULT_COUNTRY_CODE === 'IE'
              ? 'https://www.concern.net/privacy'
              : 'https://www.concern.org.uk/privacy-statement'
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          privacy policy
        </a>
        .
      </p>
    );
  }
  return null;
};

const ContactPreferencesStep = ({ text = '', options, isShortformWithOptin = false }) => (
  <>
    {DEFAULT_COUNTRY_CODE === 'IE' && <h2>We need to stay in touch</h2>}
    {DEFAULT_COUNTRY_CODE === 'GB' && <h2>Keeping you informed</h2>}
    {text && <FormattedText tag="p" text={text} />}

    {DEFAULT_COUNTRY_CODE === 'IE' && !isShortformWithOptin && (
      <p className="description">
        We rely on the generosity of compassionate people like you. Please tick the boxes below so
        we can keep you updated on our work and reach out for your continued support. We promise not
        to spam you, and you can opt out at any time.
      </p>
    )}

    {DEFAULT_COUNTRY_CODE === 'GB' && !isShortformWithOptin && (
      <>
        <p className="description">
          We&#39;d love to keep you updated about our vital work tackling extreme poverty and how
          you can help transform more lives through campaigning and appeals.
        </p>
        <p className="description">Yes - I want to hear from Concern by:</p>
      </>
    )}

    <CheckboxesField name="contact_preferences" options={options} label="" withBackground />

    {getDefaultDescriptionForContactPreferences()}
  </>
);

ContactPreferencesStep.propTypes = {
  text: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  isShortformWithOptin: PropTypes.bool,
};

export default ContactPreferencesStep;
